import React from 'react';
import { getAnalytics, logEvent } from 'firebase/analytics';

const WhatsAppFloatingButton: React.FC = () => {
  const openWhatsApp = () => {
    // Log event to Firebase Analytics
    try {
      const analytics = getAnalytics();
      logEvent(analytics, 'whatsapp_click', {
        event_category: 'engagement',
        event_label: 'floating_button',
      });
    } catch (error) {
      // Track analytics failure as error event
      try {
        const analytics = getAnalytics();
        logEvent(analytics, 'analytics_error', {
          error_type: 'whatsapp_click_tracking_failed',
        });
      } catch (trackingError) {
        // Final silent fallback - cannot track if error tracking fails
        // Could implement: localStorage error queue, console.error in dev, or external error reporting
      }
    }

    // Indonesian number: 0811-9999-331 -> wa.me requires country code without leading 0
    const waUrl = 'https://wa.me/628119999331';
    // Open in a new tab/window so desktop users don't lose the site; mobile will open the app
    window.open(waUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <button
        onClick={openWhatsApp}
        aria-label="Chat on WhatsApp"
        className="w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center group"
      >
        <img
          src="/wa-icon.png"
          alt="WhatsApp"
          className="w-8 h-8 group-hover:scale-110 transition-transform duration-300"
        />
      </button>
    </div>
  );
};

export default WhatsAppFloatingButton;
